import { IDisplayDataResponse, IUpdatePhoneBookRequest } from '@gem/models/userModel';
import { logger } from '@gem/modules/logger';

import { buildModelError } from 'APP/model/error/errorBuilder';

// Needs Bff implementation
export const addToContact = async (
  data: IUpdatePhoneBookRequest
): Promise<IDisplayDataResponse[]> => {
  try {
    const response: IDisplayDataResponse[] = [];
    return response;
  } catch (error) {
    logger.get('API').error('contact.createContact', error);
    throw buildModelError(error);
  }
};
